// src/components/card/Section.tsx

import { ExpandLessTwoTone, ExpandMoreTwoTone } from '@mui/icons-material'
import {
  Card,
  CardContent,
  CardHeader,
  Collapse,
  IconButton,
} from '@mui/material'
import { ReactNode, useState } from 'react'

import { HStack } from '../HStack'

type Props = {
  children: ReactNode
  open?: boolean
  sx?: object
  title: string | ReactNode
  actionArea?: ReactNode
}

export const Section = ({
  children,
  open: initialOpen = true,
  sx,
  title,
  actionArea,
  ...rest
}: Props) => {
  const [open, setOpen] = useState(initialOpen)

  return (
    <Card sx={{ border: 'solid 1px #ccc', mb: 3, ...sx }} {...rest}>
      <CardHeader
        action={
          <HStack>
            {actionArea}

            <IconButton>
              {open ? <ExpandMoreTwoTone /> : <ExpandLessTwoTone />}
            </IconButton>
          </HStack>
        }
        onClick={() => setOpen(prev => !prev)}
        title={title}
      />

      <Collapse in={open}>
        <CardContent>{children}</CardContent>
      </Collapse>
    </Card>
  )
}
